import styled from 'styled-components'

const ActivityTableWrapper = styled.div`
  max-width: 1200px;
`

export default ActivityTableWrapper
